import { Tag } from 'primereact/tag';
import { BenefitOrderStateId } from '../../dto/budget/BillHospOrdersSummaryDTO';

interface BenefitOrderStateTagProps {
    state: number | null;
    /** Descripción que manda el backend ("Pendiente Facturación", "Facturado"…). */
    stateName: string | null;
}

/** Estado de la orden de prestación (Novarium): pendiente = falta hacer algo, facturada o cobrada = avanzó, el resto neutro. */
export default function BenefitOrderStateTag({ state, stateName }: BenefitOrderStateTagProps) {
    if (!stateName) return null;
    let variant = 'nv-tag-neutral';
    if (state === BenefitOrderStateId.PENDING_BILLING || state === BenefitOrderStateId.PENDING_REALIZATION) variant = 'nv-tag-warn';
    if (state === BenefitOrderStateId.BILLED || state === BenefitOrderStateId.PAYED) variant = 'nv-tag-ok';
    if (state === BenefitOrderStateId.NULLED || state === BenefitOrderStateId.REJECTED) variant = 'nv-tag-err';
    return <Tag className={variant} value={stateName} />;
}
